<template>
  <header>
    <div class="mui-appbarZ" id="navbar">
      <!--   <div
        class="movil-nav-bar"
        v-bind:style="{ backgroundColor: bgColor }"
      ></div>   -->

      <v-container fluid>
        <div
          class="fondo-color"
          id="colorHeader"
          v-bind:style="{ backgroundColor: bgColor }"
        >
          <v-row class="img-row2">
            <v-img :src="image_src" class="logo-menu2" contain></v-img>
          </v-row>

          <nav class="nav1">
            <v-row class="menu-titulos2" :style="x">
              <v-col cols="4">
                <router-link to="/alquimistas" class="menu-item2">
                  <v-row id="menu-alq" @click="cambiarColor1()">
                    <p>Alquimistas & Colaboradores</p>
                  </v-row>
                </router-link>
              </v-col>

              <v-col cols="4">
                <router-link to="/manifiesto" class="menu-item2">
                  <v-row id="menu-man" @click="cambiarColor2()">
                    <p>Manifiesto</p>
                  </v-row>
                </router-link>
              </v-col>

              <v-col cols="4">
                <router-link to="/proyectos" class="menu-item2">
                  <v-row id="menu-proy" @click="cambiarColor3()">
                    <p>Proyectos</p>
                  </v-row>
                </router-link>
              </v-col>

              <v-col cols="4" class="alq-loop">
                <router-link to="/alquimistas" class="menu-item2">
                  <v-row id="menu-alq2" @click="cambiarColor1()">
                    <p>Alquimistas & Colaboradores</p>
                  </v-row>
                </router-link>
              </v-col>
            </v-row>
          </nav>
        </div>

        <!--   <div class="bloque-aux2" id="bloque-aux2" v-bind:style="{ backgroundColor: bgColor }"></div>  -->
      </v-container>
    </div>
    <div
      class="bloque-aux"
      id="bloque-aux"
      v-bind:style="{ backgroundColor: bgColor }"
    ></div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      image_src: require("../assets/logo.png"),
      bgColor: "#c8c7cc",
      opacityHeader: 1,
      xValue: 15,
      yValue: 8,
      xHeader: 0,
      yHeader: 0,
      alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
      alignment: "center",
      showNavbar: true,
      licenseKey: "265864DA-1DE54052-9BEBB977-EF50CFB8",
      parallax: true,
      parallaxKey: [
        "Y29sZWN0aXZvYWxxdWltaWEuY2xfYmxNY0dGeVlXeHNZWGc9OTJR",
        "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfdjhXY0dGeVlXeHNZWGc9QVEw",
        "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfNjI0Y0dGeVlXeHNZWGc9WVlP"
      ],
      //parallaxKey: '7CD7B03B-68104BF5-88FFE8B4-2585F4CC',
      scrollValue: 0,
      lastScrollPosition: 0,
      justifyAvailable: [
        "start",
        "center",
        "end",
        "space-around",
        "space-between"
      ],
      justify: "center"
    };
  },
  methods: {
    cambiarColor1() {
      this.bgColor = "#c8c7cc";
      this.xValue = 15;
      this.yValue = 8;
    },
    cambiarColor2() {
      this.bgColor = "#b8c9e3";
      this.xValue = -15;
      this.yValue = -27;
    },
    cambiarColor3() {
      this.bgColor = "#e6bda1";
      this.xValue = -50;
      this.yValue = -60;
    },
    hideHeader() {
      //console.log("hide");
      document.getElementById("navbar").style.top = "-60vh";
      document.getElementById("bloque-aux").style.right = "-25vw";
    },
    showHeader() {
      //console.log("show");
      document.getElementById("navbar").style.top = "0vw";
      document.getElementById("bloque-aux").style.right = "0vw";
    },
    onScroll() {}
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll, true);
  },
  computed: {
    x() {
      let width = window.innerWidth;
      if (width >= 960) {
        return `transform: translateX(${this.xValue}%)`;
      } else {
        return `transform: translateX(${this.yValue}%)`;
      }
    }
  }
};
</script>

<style lang="css">
@import "/assets/styles/main.css";

@font-face {
  font-family: Didot;
  src: url("../assets/fonts/didot-htf-m11-medium.ttf") format("truetype");
}

#navbar {
  transition: 925ms;
}
.mui-appbarZ {
  position: fixed;
  color: #c8c7cc;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  -webkit-transition-duration: 925ms;
  transition-duration: 925ms;
  z-index: 9;
}
.fondo-color {
  position: relative;
  color: "#c8c7cc";
  height: 60vh;
  width: 100%;
  transition: 925ms;
}
@media (max-width: 960px) {
  .movil-nav-bar {
    position: fixed !important;
    transition: 925ms;
    z-index: 999;
    width: 100vw;
    top: 0px;
    height: 11vh;
    opacity: 0.8;
  }
  .logo-menu2 {
    top: 10vh;
    width: 25vw;
    height: 25vh;
  }
  .bloque-aux {
    position: fixed;
    height: 100vh;
    width: 25vw;
    z-index: 1;
    top: 0vh;
    right: 0vw;
    -webkit-transition-duration: 725ms;
    transition-duration: 925ms;
  }
  .menu-titulos2 {
    transition: 925ms;
  }
  .menu-item2 {
    position: relative;
    transition: 925ms;
    font-size: calc(16.5px + 4.21875vw);
    z-index: 9999;
    color: black !important;
    margin-right: 10vw;
    padding: 0em;
    font-family: "Didot-bold";
    line-height: 1;
    font-weight: 300;
    word-break: keep-all;
  }
  .menu-item2:active {
    transition: 925ms;
    font-size: calc(16.5px + 4.21875vw);
    z-index: 9999;
    color: black !important;
    margin-right: 10vw;
  }
  .menu-item2:visited {
    transition: 925ms;
    font-size: calc(16.5px + 4.21875vw);
    z-index: 9999;
    color: black !important;
    margin-right: 10vw;
  }
  .menu-item2:hover {
    transition: 925ms;
    font-size: calc(16.5px + 4.21875vw);
    z-index: 9999;
    color: black !important;
    margin-right: 10vw;
  }
  #menu-alq::before {
    content: "";
    position: absolute;
    margin-top: 25px;
    margin-right: 15px;
    right: 100%;
    cursor: default;
    width: 1.2em;
    height: 2px;
    background: #000;
    z-index: 9999;
  }
  #menu-man::before {
    content: "";
    position: relative;
    cursor: default;
    width: 1.2em;
    margin-top: 10px;
    right: 0vw;
    height: 2px;
    background: #000;
    z-index: 9999;
  }
  #menu-proy::before {
    content: "";
    position: relative;
    cursor: default;
    right: 0vw;
    margin-top: 10px;
    width: 1.2em;
    height: 2px;
    background: #000;
    z-index: 9999;
  }
  #menu-alq2::before {
    content: "";
    position: absolute;
    cursor: default;
    margin-top: 25px;
    margin-right: 15px;
    right: 100%;
    width: 1.2em;
    height: 2px;
    background: #000;
    z-index: 9999;
  }
  .nav1 {
    padding-top: 20vh;
    height: 200px;
    transition: 925ms cubic-bezier(0.445, 0.05, 0.015, 1);
    width: 200vw;
  }
  .alq-loop {
    position: absolute;
    right: -38%;
    top: 0%;
  }
}
@media (min-width: 960px) {
  .img-row2 {
    position: relative;
  }
  .logo-menu2 {
    top: 5vh;
    width: 30vw;
    height: 30vh;
  }
  .bloque-aux {
    position: fixed;
    height: 100vh;
    width: 20vw;
    z-index: 1;
    top: 0vh;
    right: 0vw;
    -webkit-transition-duration: 925ms;
    transition-duration: 925ms;
  }
  .bloque-aux2 {
    position: fixed;
    height: 100vh;
    width: 7vw;
    bottom: 0vh;
    left: 0vw;
    z-index: -1;
    transition: 925ms cubic-bezier(0.945, 0.65, 0.515, 0.9);
  }
  .menu-titulos2 {
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
    margin: 0;
  }
  .menu-item2 {
    position: relative;
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
    font-size: calc(16.5px + 4.21875vw);
    padding-right: 10vw;
    max-width: 20vw;
    cursor: pointer;
    padding: 0em;
    font-family: "Didot-bold";
    line-height: 1;
    font-weight: 300;
    word-break: keep-all;
  }
  #menu-alq::before {
    content: "";
    position: absolute;
    margin-top: 50px;
    margin-right: 10px;
    right: 100%;
    cursor: default;
    width: 1.5em;
    height: 3px;
    background: #000;
    z-index: 3;
  }
  #menu-man::before {
    content: "";
    position: relative;
    cursor: default;
    right: 0vw;
    margin-top: 35px;
    margin-right: 10px;
    width: 1.5em;
    height: 3px;
    background: #000;
    z-index: 3;
  }
  #menu-proy::before {
    content: "";
    position: relative;
    cursor: default;
    right: 0vw;
    margin-top: 35px;
    margin-right: 10px;
    width: 1.5em;
    height: 3px;
    background: #000;
    z-index: 3;
  }
  #menu-alq2::before {
    content: "";
    position: absolute;
    cursor: default;
    margin-top: 50px;
    margin-right: 10px;
    right: 100%;
    width: 1.5em;
    height: 3px;
    background: #000;
    z-index: 3;
  }
  .nav1 {
    padding-top: 5vh;
    height: 200px;
    transition: 925ms;
    z-index: 3;
    width: 180vw;
  }
  .nav1:hover {
    transform: translateZ(0px) translateX(-5.7837vw);
  }
  .alq-loop {
    position: absolute;
    right: -35%;
    top: 0%;
  }
}
</style>
